import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from '../shared/themeShared';

const helpers = createMultiStyleConfigHelpers([
  'base',
  'complete',
  'empty',
  'invalid',
]);

const baseStyle = (theme: ThemesKeys) => ({
  container: {
    padding: `${getThemes(theme).space[2.5]} ${getThemes(theme).space[3]}`,
    borderRadius: 6,
    _hover: {
      ':not(.focus):not(.error)': {
        boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.primary[0]} !important`,
      },
    },
    _blur: {
      boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.neutral[60]}`,
    },
    _blurError: {
      boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.form.error[0]}`,
    },
    _focusVisible: {
      outline: 'none',
      boxShadow: `0 0 0 2px ${getThemes(theme).colors.palette.primary[0]}`,
    },
    _focusVisibleError: {
      outline: 'none',
      boxShadow: `0 0 0 2px ${getThemes(theme).colors.palette.form.error[0]}`,
    },
  },
  base: {
    fontSize: getThemes(theme).fontSizes.xl,
    color: getThemes(theme).colors.palette.primary[0],
    fontWeight: 300,
    '::placeholder': {
      color: getThemes(theme).colors.palette.primary[70],
      fontWeight: 300,
    },
  },
  complete: {},
  empty: {},
  invalid: {
    color: getThemes(theme).colors.palette.form.error[0],
  },
});

const StripeInput = (theme: ThemesKeys) =>
  helpers.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
  });

export default StripeInput;
